import { render } from "./RegisterItensForm.vue?vue&type=template&id=3fd46ad2&scoped=true"
import script from "./RegisterItensForm.vue?vue&type=script&lang=js"
export * from "./RegisterItensForm.vue?vue&type=script&lang=js"

import "./RegisterItensForm.vue?vue&type=style&index=0&id=3fd46ad2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd46ad2"]])

export default __exports__